import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Box from "@material-ui/core/Box";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { withTranslation, useTranslation } from "react-i18next";
import "./ShipmentList.scss";
import { Link } from "react-router-dom";
import IsImgChecked from "../../components/IsImgChecked/IsImgChecked";
import ShipmentStatus from "./ShipmentStatus";
import newImg from "../../assets/img/new.gif";
import moment from "moment";
import "moment-timezone";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    borderBottom: "1px solid rgba(196, 196, 196, 0.5)",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(() => ({
  root: {
    padding: "25px",
    textAlign: "center",
  },
}))(MuiDialogContent);

function MyShipmentList(props) {
  let userName = localStorage.getItem("userData");
  userName = JSON.parse(userName);
  const countryCode = userName ? userName.countryCode : "TH";
  const { t } = useTranslation();
  const [shipData, setShipData] = useState(props.productShipList);
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const selectedLangCode = localStorage.getItem("lancode");
  let selectedQuantity = 0;
  function isEmpty(str) {
    return !str || str.length === 0;
  }
  const checkDecimalVal = (val) => {
    let checkDecimalLen = String(val).split(".");
    return checkDecimalLen[1] !== undefined && checkDecimalLen[1].length >= 3
      ? Number(val).toFixed(3)
      : val;
  };

  const SmallFontChanger = useSelector(
    (state) => state.smallfontchanger.smallfontchanger,
  );
  const FontChange = useSelector(
    (state) => state.fontsizechanger.fontsizechanger,
  );

  const isProcessing = shipData.shippingStatus === "Processing" && isEmpty(shipData.shipmentNumber);
  const isBlocked = shipData.shippingStatus === "Blocked" && isEmpty(shipData.shipmentNumber);
  const isPickup = props.shipingCondition === 0;

  const pickupUrl = `/ShipmentDetails-Pickup?countryCode=${countryCode}&inseeplusUID=${shipData.inseeplusUID}&shipmentId=${shipData.shipmentNumber}&shipToCode=${shipData.shipTo}`;

  const deliveryUrl = `/ShipmentDetails-Delivery?countryCode=${countryCode}&inseeplusUID=${shipData.inseeplusUID}&shipmentId=${shipData.shipmentNumber}&shipToCode=${shipData.shipTo}`;

  return (
    <>
      <div className="container-fluid mt-2 mb-2">
        <div className="shipmentListItemContainer">
          <div className="col-12">
            <div className="Rectangle-2231 row">
              <span
                className="PO-No-1287586 col-xl-2 col-lg-2 col-md-4 col-sm-12 col-xs-12 pl-0 pr-0 mb-2"
                style={{ fontSize: `${SmallFontChanger}px` }}
              >
                <span
                  className="item_text"
                  style={{ fontSize: `${SmallFontChanger}px` }}
                >
                  {t("myshipmentlist.heading")}:{" "}
                  {shipData.shipmentNumber
                    ? shipData.shipmentNumber.includes("SH")
                      ? shipData.shipmentNumber
                      : ""
                    : ""}
                </span>
              </span>

              <span
                className="SO-No-1208767 col-xl-2 col-lg-2 col-md-4 col-sm-12 col-xs-12 pl-0 pr-0 mb-2"
                style={{ fontSize: `${SmallFontChanger}px` }}
              >
                <span
                  className="item_text"
                  style={{ fontSize: `${SmallFontChanger}px` }}
                >
                  {" "}
                  {t("shipmentdetail.shipmentdate")}:{" "}
                  {shipData.shipmentCreationDate}
                </span>{" "}
              </span>
              <span
                className="SO-Date-12102020 col-xl-2 col-lg-2 col-md-4 col-sm-12 col-xs-12 pl-0 pr-0 mb-2"
                style={{ fontSize: `${SmallFontChanger}px` }}
              >
                <span
                  className="item_text"
                  style={{ fontSize: `${SmallFontChanger}px` }}
                >
                  {t("createdelivery.shipto")}:{" "}
                  {countryCode && countryCode === "VN"
                    ? shipData &&
                      shipData.shipTos &&
                      shipData.shipTos != null &&
                      shipData.shipTos != undefined
                      ? shipData.shipTos.map((shipTO) => {
                          return selectedLangCode === "en" ||
                            selectedLangCode === null
                            ? shipTO.shipToCode && shipTO.shipToCode != null
                              ? shipTO.shipToCode.replace(/^0+/, "") +
                                " " +
                                shipTO.shipToName
                              : ""
                            : shipTO.shipToCode && shipTO.shipToCode != null
                              ? shipTO.shipToCode.replace(/^0+/, "") +
                                " " +
                                shipTO.shipToName
                              : "";
                        })
                      : ""
                    : selectedLangCode === "en" || selectedLangCode === null
                      ? shipData.shipTo.replace(/^0+/, "") +
                        " " +
                        shipData.shipToName
                      : shipData.shipTo.replace(/^0+/, "") +
                        " " +
                        shipData.shipToNameInLocal}
                </span>
              </span>
              <span
                className="Plant-Thap-Kwang-Thailand col-xl-2 col-lg-2 col-md-4 col-sm-12 col-xs-12 pl-0 pr-0 mb-2"
                style={{ fontSize: `${SmallFontChanger}px` }}
              >
                <span
                  className="item_text"
                  style={{ fontSize: `${SmallFontChanger}px` }}
                >
                  {t("Plant")}: {shipData.plantName}
                </span>
              </span>
              {countryCode && countryCode === "VN" ? (
                ""
              ) : (
                <span
                  className="Order-Type-Credit col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 pl-0 pr-0"
                  style={{ fontSize: `${SmallFontChanger}px` }}
                >
                  <span
                    className="item_text"
                    style={{ fontSize: `${SmallFontChanger}px` }}
                  >
                    {t("shipmanagement.shipmentstatus")}:{" "}
                    <ShipmentStatus status={shipData.shippingStatus} />
                  </span>
                </span>
              )}
              <span className="newIcon">
                {shipData.shipmentCreationDate ===
                moment().format("DD/MM/YYYY") ? (
                  <img src={newImg} style={{ width: "50px" }} />
                ) : (
                  ""
                )}
              </span>
            </div>
          </div>
          <div className="col-12">
            {shipData &&
              shipData.products.map((prod, key) => {
                selectedQuantity =
                  selectedQuantity +
                  parseFloat(Number(prod.selectedQuantity).toFixed(3));
                return (
                  <div
                    key={key}
                    className="Rectangle-2232 row MyShipmentListContainer"
                  >
                    <span className="product_name productName col-xl-3 col-lg-4 col-md-12 col-sm-6 col-xs-12 pl-0 mb-3">
                      <span className="productImg">
                        <IsImgChecked
                          imageUrl={`${prod.productImage}?${new Date().getTime()}`}
                        />
                      </span>
                      <span
                        className="ml-2 prod_name"
                        style={{ fontSize: `${SmallFontChanger}px` }}
                      >
                        <strong style={{ fontSize: `${SmallFontChanger}px` }}>
                          {selectedLangCode === "en" ||
                          selectedLangCode === null
                            ? prod && prod.productName
                              ? prod.productName.split(":")[1]
                              : ""
                            : prod && prod.productName
                              ? prod.productName.split(":")[0]
                              : ""}
                        </strong>
                      </span>

                      <span
                        className="product_id ml-2 "
                        style={{ fontSize: `${SmallFontChanger}px` }}
                      >
                        <strong style={{ fontSize: `${SmallFontChanger}px` }}>
                          {prod.productId
                            ? prod.productId.replace(/^0+/, "")
                            : ""}
                        </strong>
                      </span>
                    </span>
                    {countryCode && countryCode === "VN" ? (
                      <span
                        className="product_id productId col-xl-2 col-lg-4 col-md-4 col-sm-6 col-xs-12 mb-3"
                        style={{
                          lineHeight: "18px",
                          fontSize: `${SmallFontChanger}px`,
                        }}
                      >
                        {t("shipmanagement.shipmentstatus")} : <br />
                        {prod.doStatus}
                      </span>
                    ) : (
                      <span
                        className="product_id productId col-xl-2 col-lg-4 col-md-4 col-sm-6 col-xs-12 mb-3"
                        style={{
                          lineHeight: "18px",
                          fontSize: `${SmallFontChanger}px`,
                        }}
                      >
                        {t("label.po_number")} : <br />
                        {shipData.poNumber[key]}
                      </span>
                    )}
                    <span
                      className="product_id productId14 col-xl-2 col-lg-4 col-md-4 col-sm-6 col-xs-12 mb-3"
                      style={{
                        lineHeight: "18px",
                        fontSize: `${SmallFontChanger}px`,
                      }}
                    >
                      {t("label.so_number")} : <br />
                      {prod.soNo}
                    </span>
                    <span
                      className="product_id productId14 col-xl-1 col-lg-4 col-md-4 col-sm-6 col-xs-12 mb-3"
                      style={{
                        lineHeight: "18px",
                        fontSize: `${SmallFontChanger}px`,
                      }}
                    >
                      {t("shipmanagement.donumber")}: <br />
                      {countryCode && countryCode === "VN"
                        ? prod.doNumber !== ""
                          ? prod.doNumber
                          : ""
                        : prod.deliveryNumberSap !== ""
                          ? prod.deliveryNumberSap
                          : ""}
                    </span>
                    <span
                      className="product_name productId16 col-xl-2 col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-3"
                      style={{ fontSize: `${SmallFontChanger}px` }}
                    >
                      {t("selectedQuantity")}{" "}
                      {checkDecimalVal(
                        parseFloat(prod.selectedQuantity).toFixed(3),
                      )}{" "}
                      {selectedLangCode === "en" || selectedLangCode === null
                        ? prod.unitOfMeasure
                        : selectedLangCode === "vt"
                          ? prod.unitOfMeasure === "TON"
                            ? "tấn"
                            : prod.unitOfMeasure === "Each"
                              ? "ชิ้น"
                              : prod.unitOfMeasure === "Set"
                                ? "ชุด"
                                : prod.unitOfMeasure
                          : prod.unitOfMeasure === "TON"
                            ? "ตัน"
                            : prod.unitOfMeasure === "Each"
                              ? "ชิ้น"
                              : prod.unitOfMeasure === "Set"
                                ? "ชุด"
                                : prod.unitOfMeasure}
                    </span>
                  </div>
                );
              })}
          </div>
          <div>
            <div className="Rectangle-110 MyShpCrdFtr">
              <span
                className="Total-Amount-50000 col-md-6 col-sm-6 col-sx-12 myShipmntTotalTon"
                style={{ fontSize: `${SmallFontChanger}px` }}
              >
                {t("total.label")} :{" "}
                {checkDecimalVal(parseFloat(selectedQuantity).toFixed(3))}{" "}
                {t("ton.weighttype")}
              </span>
              <span className="col-md-6 col-sm-6  col-sx-12 text-md-right pl-0 shpmntDetailBtnPhn d-flex justify-content-sm-end justify-content-center">
                {isProcessing ? (
                  <button
                    onClick={() => setOpen(true)}
                    className="create_btn_order shipmentDetBtn"
                    style={{ fontSize: `${FontChange}px` }}
                  >
                    {t("Shipment Detail")}
                  </button>
                ) : isBlocked ? (
                  <button
                    onClick={() => setOpen(true)}
                    className="create_btn_order shipmentDetBtn"
                    style={{ fontSize: `${FontChange}px` }}
                  >
                    {t("Shipment Detail")}
                  </button>
                ) : (
                  <Link to={isPickup ? pickupUrl : deliveryUrl}>
                    <button
                      className="create_btn_order shipmentDetBtn"
                      style={{ fontSize: `${FontChange}px` }}
                    >
                      {t("Shipment Detail")}
                    </button>
                  </Link>
                )}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="select_shipment_boxes">
        <Dialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
          PaperProps={{
            sx: { borderRadius: "15px" },
          }}
        >
          {/* ✅ Header with gap */}
          <DialogTitle id="customized-dialog-title">
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between", // ✅ pushes cross to right
                gap: 2, // ✅ space between header text and cross
              }}
            >
              <Typography
                sx={{
                  fontSize: "12px",
                  mt: "6px",
                }}
              >
                {isProcessing && t("Shipment Status Processing")}
                {isBlocked && t("shipmentBlockedHeading")}
              </Typography>

              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>

          <DialogContent sx={{ width: "100%" }}>
            <Typography sx={{ fontSize: "15px" }}>
              {isProcessing && t("Shipment creation is process")}
              {isBlocked && t("shipmentBlockedMessage")}
            </Typography>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
}
export default withTranslation()(MyShipmentList);
